import { render, staticRenderFns } from "./TaxonomyActionDelete.vue?vue&type=template&id=1fb5e75c&"
import script from "./TaxonomyActionDelete.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports